import { action } from "mobx";
import NestStore from "~/stores/NestStore";
import UiMeet3dLinkPairRepository from "~/repository/UiMeet3d/UiMeet3dLinkPairRepository";

class UiMeet3dLinkPairStore extends NestStore {
  uiMeet3dLinkPairRepository = null;

  constructor() {
    super();

    this.uiMeet3dLinkPairRepository = new UiMeet3dLinkPairRepository();
  }

  @action
  create(data) {
    this.isSaving = true;

    return this.uiMeet3dLinkPairRepository
      .create(this.locale, data)
      .then(() => {
        this.isSaving = false;
      })
      .catch(e => {
        this.isSaving = false;
        this.setErrorMessages(e);
        throw e;
      });
  }

  @action
  update(roomId, data) {
    this.isSaving = true;
    this.clearErrorMessages();

    return this.uiMeet3dLinkPairRepository
      .update(this.locale, roomId, data)
      .then(() => {
        this.isSaving = false;
      })
      .catch(e => {
        this.isSaving = false;
        this.setErrorMessages(e);
        throw e;
      });
  }

  @action
  delete(roomId) {
    this.isSaving = true;

    return this.uiMeet3dLinkPairRepository
      .delete(this.locale, roomId)
      .catch(e => {
        this.isSaving = false;
        this.setErrorMessages(e);
        throw e;
      })
      .finally(() => {
        this.isSaving = false;
      });
  }
}

export default UiMeet3dLinkPairStore;
